import SpotWeldingSvg from '_icons/workingSteps/spot_welding-sm.svg?react'
import { forwardRef, type SVGProps } from 'react'

/** Spot Welding icon using the shared working-step SVG styling. */
export const SpotWeldingIcon = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement>
>(({ className, ...props }, ref) => (
  <SpotWeldingSvg
    width={32}
    height={32}
    {...props}
    className={`icon${className ? ` ${className}` : ''}`}
    ref={ref}
  />
))

SpotWeldingIcon.displayName = 'SpotWeldingIcon'
